<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="店铺简称" prop="storeCode">
            <el-select v-model="searchForm.storeCode" clearable filterable @change="onSearch">
              <el-option v-for="item in storeList" :key="item.storeCode" :label="item.shortName" :value="item.storeCode" />
            </el-select>
          </el-form-item>
          <el-form-item label="新品上架" prop="newArrival">
            <el-select v-model="searchForm.newArrival" clearable @change="onSearch">
              <el-option label="是" :value="1" />
              <el-option label="否" :value="0" />
            </el-select>
          </el-form-item>
          <el-form-item label="在售品信息处理" prop="onSaleUpdate">
            <el-select v-model="searchForm.onSaleUpdate" clearable  @change="onSearch">
              <el-option label="是" :value="1" />
              <el-option label="否" :value="0" />
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <span>店铺信息</span>
      </template>
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column prop="platformName" label="平台名称" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="storeName" label="店铺名称" min-width="180"></el-table-column>
        <el-table-column prop="shortName" label="店铺简称" min-width="150"></el-table-column>
        <el-table-column prop="storeManagerUser" label="店长" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="newArrival" label="新品上架" min-width="80">
          <template slot-scope="{ row }">
            <span :class="row.newArrival == '否' && 'red-text'">{{ row.newArrival }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="onSaleUpdate" label="在售品信息处理" min-width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="operationUser" label="运营负责人" min-width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="beforeSaleUser" label="售前客服组长" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="onSaleUser" label="售中客服组长" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="afterSaleUser" label="售后客服组长" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateUser" label="更新人" min-width="80"></el-table-column>
        <el-table-column prop="lastUpdateDate" label="更新时间" min-width="160"></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <editDialog :visible.sync="isShowEdit" v-if="isShowEdit" :rowData="rowData" :userList="userList" @success="onSearch" />
  </content-panel>
</template>

<script>
import axios from "@/utils/axiosInstance";
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import editDialog from './components/edit';

export default {
  name: 'StroeMangement',
  mixins: [tableMixin, pagePathMixin],
  components: {
    editDialog,
  },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      isShowEdit: false,
      searchFormData: [],
      rules: {},
      rowData: {},
      storeList: [],
      userList: [],
      searchForm: {
        storeShortName: '',
        newArrival: '',
        onSaleUpdate: '',
      },
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [],
        orderList: [],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: this.searchForm,
      };
      this.searchFormData = data;
      this.$q.configurationCenter
        .storeManagePage({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    handleEdit(row) {
      this.isShowEdit = true;
      this.rowData = { ...row };
    },

    getStoreList() {
      let data = { ...this.currencyForm };
      data.reportCode = "smallPiecesStoreConfigList";
      axios.post(`/ec-pc-api/custom/reports/data/smallPiecesStoreConfigList`, data).then((res) => {
        if (res.code == 200) {
          this.storeList = res.data.list.filter(v=>v.storeName != '全平台');
        }
      });
    },

    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: '导出中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-new',
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: 'storeManagementExport',
      };
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  mounted() {
    this.getStoreList()
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
.search-box {
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input {
    width: 240px !important;
  }
}

>>> .date-range .single-date {
  width: 110px !important;
}

>>> .form-number-input .el-input-number {
  width: 105px !important;
}

>>> .form-number-input .el-input-number .el-input {
  width: 105px !important;
}

.red-text {
  color: red;
}
</style>
